// extracted by mini-css-extract-plugin
module.exports =  {"area-link":"_32bbee5fda--area-link--kdMoG"};